import { FirestoreDataConverter } from "firebase/firestore";
import Plano from "../models/plano";
import BaseDb from "./baseDb";

export default class PlanoDb extends BaseDb<Plano, { planoId: string }> {
  _path: string = "planos/planoId";
  getConverter(): FirestoreDataConverter<Plano> {
    return {
      fromFirestore: (snapshot, _options) => {
        return {
          id: snapshot.id,
          active: snapshot.get("active"),
          description: snapshot.get("description"),
          images: snapshot.get("images"),
          metadata: snapshot.get("metadata"),
          name: snapshot.get("name"),
          role: snapshot.get("role"),
          perfil: snapshot.get("metadata.perfil"),
          precos: [],
        };
      },
      toFirestore: (_plano: Plano) => {
        throw new Error("Não é possível criar um preço");
      },
    };
  }
}
